import React, { useState, useEffect, Fragment } from "react";
import { API_URL } from "../helpers";
import Alert from "../components/Alert";
import Input from "../components/Input";
import Textarea from "../components/Textarea";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const Form1 = ({ token, update }) => {
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({
		token,
	});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	useEffect(() => {
		init();

		// eslint-disable-next-line
	}, []);

	const init = async () => {
		const url = new URL(`${API_URL}/auth/charityForm1Init`);
		const params = {
			token: names.token,
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				handleUpdate("mission", json.mission);
				handleUpdate("impacted", json.impacted);
				handleUpdate("goal", json.goal);
				setAlert({});
			} else {
				setAlert({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/auth/charityForm1`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				update("form", 0);
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<Fragment>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<form
					method="post"
					action="/"
					onSubmit={(e) => handleSubmit(e)}
					className="well"
				>
					<h3 style={{ marginTop: "0" }}>
						Charity Mission & Fundraising Goals
					</h3>

					<p>
						Use this form to customize the mission statement, impacted text and
						fundraising goal amount on your donation from.
					</p>

					<div className="form-group">
						<Textarea
							name="mission"
							label="Charity Mission"
							reqd={true}
							value={names.mission || ""}
							update={handleUpdate}
							errors={errors}
						/>
						<Textarea
							name="impacted"
							label="How many will be impacted and in what way?"
							reqd={true}
							value={names.impacted || ""}
							update={handleUpdate}
							errors={errors}
							note="Note: Please use a complete sentence to show greatest impact details."
						/>
					</div>

					<div className="form-group">
						<Input
							name="goal"
							label="Fundraising Goal for 2026-2027 Campaign ($)"
							reqd={true}
							value={names.goal || ""}
							update={handleUpdate}
							errors={errors}
						/>
						<div />
					</div>

					<div className="msg-submit">
						{msg.type && <Msg data={msg} />}

						<div
							className={
								msg.type === "working" || msg.type === "success"
									? "hidden"
									: "submit-container"
							}
						>
							<Submit path="" left="" submit="Submit Changes" />
						</div>
					</div>
				</form>
			)}
		</Fragment>
	);
};

export default Form1;
